import { Link } from 'react-router-dom';
import { Heart, MoreVertical } from 'lucide-react';
import { VEHICLE_PLACEHOLDER_URL } from '../../constants/vehiclePlaceholder';
import { useToast } from '../../contexts/ToastContext';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocale } from '../../contexts/LocaleContext';
import { removeFromWishlist } from '../../features/wishlist/wishlistSlice';
import '../AllCss/WishlistCarCard.css';

function WishlistCarCard({ car, viewMode }) {
  const toast = useToast();
  const [showMenu, setShowMenu] = useState(false);
  const dispatch = useDispatch();
  const { t } = useLocale();

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    }).format(price);
  };

  const formatMileage = (mileage) => {
    return `${Number(mileage).toLocaleString()}K mi`;
  };

  const handleWishlistToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Remove from Redux wishlist
    dispatch(removeFromWishlist(car.id));
    // TODO: API call to sync with backend
  };

  const handleMenuToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowMenu(!showMenu);
  };

  const handleRemove = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(removeFromWishlist(car.id));
    setShowMenu(false);
  };

  const handleShare = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const carUrl = `${window.location.origin}/cars/${car.stockNumber || car.id}`;
    const shareData = {
      title: `${car.year} ${car.make} ${car.model}`,
      text: `Check out this ${car.year} ${car.make} ${car.model} - ${formatPrice(car.price)}`,
      url: carUrl,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        // Fallback: Copy to clipboard
        await navigator.clipboard.writeText(carUrl);
        toast.success('Link copied to clipboard!');
      }
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('Error sharing:', err);
      }
    }
    
    setShowMenu(false);
  };

  const imageUrl = car.images && car.images.length > 0
    ? car.images[0]
    : VEHICLE_PLACEHOLDER_URL;

  return (
    <Link
      to={`/cars/${car.stockNumber || car.id}`}
      className={`WishlistCarCard ${viewMode}`}
      draggable={false}
      onDragStart={(e) => e.preventDefault()}
    >
      {/* Image */}
      <div className="wishlist-card-image-container">
        <img
          src={imageUrl}
          alt={`${car.year} ${car.make} ${car.model}`}
          className="wishlist-card-image"
          draggable={false}
        />
        
        {/* Heart Icon */}
        <button
          className="wishlist-heart-btn active"
          onClick={handleWishlistToggle}
          aria-label="Remove from wishlist"
        >
          <Heart size={20} fill="currentColor" />
        </button>

        {/* More Menu */}
        <div className="wishlist-menu-container">
          <button
            className="wishlist-menu-btn"
            onClick={handleMenuToggle}
            aria-label="More options"
          >
            <MoreVertical size={20} />
          </button>
          
          {showMenu && (
            <div className="wishlist-menu-dropdown">
              <button className="menu-item" onClick={handleShare}>Share</button>
              <button className="menu-item" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setShowMenu(false); }}>Compare</button>
              <button className="menu-item danger" onClick={handleRemove}>Remove</button>
            </div>
          )}
        </div>
      </div>

      {/* Content */}
      <div className="wishlist-card-content">
        <h3 className="wishlist-card-title">
          {car.year} {car.make}
        </h3>
        <p className="wishlist-card-model">{car.model}</p>

        <div className="wishlist-card-details">
          <span className="condition-badge">{car.condition ? car.condition.toUpperCase() : 'USED'}</span>
          <span className="mileage">{formatMileage(car.mileage / 1000)}</span>
        </div>

        <div className="wishlist-card-price">
          <span className="price">{formatPrice(car.price)}*</span>
          <span className="price-note">Estimated ${Math.round((car.price * 0.02) / 12)}/mo</span>
          <span className="cash-down">$0 cash down</span>
        </div>
      </div>
    </Link>
  );
}

export default WishlistCarCard;

